export class AssociateTeamWithVaultRequestEntry {
    teamId: number;
    encryptedTeamKey: string;
}